import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SingleSponsorContentRoutingModule } from './single-sponsor-content-routing.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';
import { SharedFormSectionsModule } from '../shared-form-sections/shared-form-sections.module';
import { SharedModule } from '../shared/shared.module';
import { SingleSponsorContentFormComponent } from './components/single-sponsor-content-form/single-sponsor-content-form.component';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
  declarations: [SingleSponsorContentFormComponent],
  imports: [
    CommonModule,
    SingleSponsorContentRoutingModule,
    SharedModule,
    SharedFormSectionsModule,
    RouterModule,
    MatSnackBarModule,
    MatDialogModule,
    MatTabsModule,
  ],
})
export class SingleSponsorContentModule {}
